import { Component } from "@angular/core";
import { expandingFabAnimations } from "@/_utility/animations";

@Component({
    templateUrl: "./statistics.component.html",
    styleUrls: ["./statistics.component.scss"],
    animations: [expandingFabAnimations],
})
export class StatisticsComponent {
    constructor() {}

    ngOnInit(): void {}
}
